// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2f42v","clinicsSelect":"TableHeading_clinicsSelect__3jHvD"};